function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon_settings");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icon_settings",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.9132979,11.6000517 C20.5392969,12.5470527 20.9042969,13.6830517 20.9042969,14.9040527 C20.9042969,18.2180517 18.2182959,20.9040527 14.9042969,20.9040527 C11.5902979,20.9040527 8.9042969,18.2180517 8.9042969,14.9040527 C8.9042969,11.5900537 11.5902979,8.9040527 14.9042969,8.9040527 C16.0302959,8.9040527 17.0842969,9.2140517 17.9852959,9.7540527",
  id: "Stroke-1",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.9012969,1.6410532 L21.6662959,6.2400531 C22.3752979,6.7950525 23.0132979,7.433052 23.5682979,8.1420537 L28.1672969,7.9070527",
  id: "Stroke-2",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.2362979,10.4680517 L25.8132969,13.5580517 C25.8682979,14.0000537 25.9042969,14.4470517 25.9042969,14.9040527 C25.9042969,15.3610537 25.8682979,15.8080517 25.8132969,16.2500537 L29.2362979,19.3400537",
  id: "Stroke-3",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.3402979,29.2360537 L16.2502979,25.8130527 C15.8082959,25.8680537 15.3612979,25.9040527 14.9042969,25.9040527 C14.4472959,25.9040527 14.0002979,25.8680537 13.5582959,25.8130527 L10.4682959,29.2360537",
  id: "Stroke-4",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.1672969,21.9010527 L23.5682979,21.6660517 C23.0132979,22.3750537 22.3752979,23.0130537 21.6662959,23.5680537 L21.9012969,28.1670527",
  id: "Stroke-5",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.9072969,28.1670527 L8.1422979,23.5680537 C7.4332962,23.0130537 6.7952967,22.3750537 6.2402973,21.6660517 L1.6412974,21.9010527",
  id: "Stroke-6",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.5722971,19.3400537 L3.9952965,16.2500537 C3.9402972,15.8080517 3.9042969,15.3610537 3.9042969,14.9040527 C3.9042969,14.4470517 3.9402972,14.0000537 3.9952965,13.5580517 L0.5722971,10.4680517",
  id: "Stroke-7",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.4682959,0.5720529 L13.5582959,3.9950523 C14.0002979,3.940053 14.4472959,3.9040527 14.9042969,3.9040527 C15.3612979,3.9040527 15.8082959,3.940053 16.2502979,3.9950523 L19.3402979,0.5720529",
  id: "Stroke-8",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.6412974,7.9070527 L6.2402973,8.1420537 C6.7952967,7.433052 7.4332962,6.7950525 8.1422979,6.2400531 L7.9072969,1.6410532",
  id: "Stroke-9",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.1422979,23.5680537 L7.9072969,28.1670527 C8.7202969,28.5970537 9.5752969,28.9600527 10.4682959,29.2360537 L13.5582959,25.8130527",
  id: "Stroke-10",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.9952965,16.2500537 L0.5722971,19.3400537 C0.8482971,20.2330527 1.2112971,21.0880527 1.6412974,21.9010527 L6.2402973,21.6660517",
  id: "Stroke-11",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.5682979,21.6660517 L28.1672969,21.9010527 C28.5972979,21.0880527 28.9602969,20.2330527 29.2362979,19.3400537 L25.8132969,16.2500537",
  id: "Stroke-12",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.2502979,25.8130527 L19.3402979,29.2360537 C20.2332969,28.9600527 21.0882969,28.5970537 21.9012969,28.1670527 L21.6662959,23.5680537",
  id: "Stroke-13",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5582959,3.9950523 L10.4682959,0.5720529 C9.5752969,0.8480529 8.7202969,1.2110529 7.9072969,1.6410532 L8.1422979,6.2400531",
  id: "Stroke-14",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.8132969,13.5580517 L29.2362979,10.4680517 C28.9602969,9.5750527 28.5972979,8.7200527 28.1672969,7.9070527 L23.5682979,8.1420537",
  id: "Stroke-15",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.2402973,8.1420537 L1.6412974,7.9070527 C1.2112971,8.7200527 0.8482971,9.5750527 0.5722971,10.4680517 L3.9952965,13.5580517",
  id: "Stroke-16",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.6662959,6.2400531 L21.9012969,1.6410532 C21.0882969,1.2110529 20.2332969,0.8480529 19.3402979,0.5720529 L16.2502979,3.9950523",
  id: "Stroke-17",
  stroke: "#000000"
}));

var SvgIconSettings = function SvgIconSettings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_settings.1443de4f.svg";
export { ForwardRef as ReactComponent };